var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLookRightGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.24688 6.05352C1.07813 6.05352 0.9375 6.18477 0.9375 6.36289V7.68477C0.9375 7.85352 1.06875 7.99414 1.24688 7.99414H19.4062L14.8031 12.4285C14.6812 12.5504 14.6812 12.7379 14.8031 12.8598L15.7406 13.7973C15.8625 13.9191 16.05 13.9191 16.1719 13.7973L22.0219 8.16289C22.0312 8.16289 22.0312 8.15352 22.0406 8.14414L22.0687 8.11602L22.9781 7.24414C23.0438 7.17852 23.0719 7.09414 23.0625 7.00977C23.0625 6.92539 23.0344 6.84102 22.9781 6.77539L22.0781 5.90352L22.05 5.87539C22.0406 5.86602 22.0406 5.86602 22.0312 5.85664L16.1813 0.222266C16.0594 0.100391 15.8719 0.100391 15.75 0.222266L14.8125 1.15977C14.6906 1.28164 14.6906 1.46914 14.8125 1.59102L19.4625 6.07227H1.24688V6.05352Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLookRightGreen);
export default __webpack_public_path__ + "static/media/arrow-look-right-green.0b21d2f7066fabe5e7a1e4404ae9d84f.svg";
export { ForwardRef as ReactComponent };